import {
    AfterViewInit,
    AfterContentInit,
    Component,
} from "@angular/core";

import { ToastService, ToastSettings, ToastType } from "@indusoft/toast";
import { OverlayWindowRef } from '@indusoft/overlay-window';

import { IDictionary } from "../../common/models/i-dictionary";
import { LicenseHttpService } from '../../common/services/license-http-service';
import { LicenseInfoDto } from "../../common/dtos/license-info-dto";
import { PermitStatus } from "../../common/enums/permit-status";

@Component({
    selector: 'license',
    templateUrl: 'license.component.html',
    styleUrls: ['license.component.css']
})

export class LicenseComponent implements AfterViewInit, AfterContentInit {
    public header: string;
    public licenseInfoText: string;
    public licenseInfo: LicenseInfoDto;
    public iconClass: string = '';

    constructor(
        private toastService: ToastService,
        private overlayWindow: OverlayWindowRef,
        private readonly licenseHttpService: LicenseHttpService
    ) { }

    ngAfterContentInit(): void {
        this.setLicenseInfo();
    }

    public ngAfterViewInit(): void {
    }

    public close(): void {
        this.overlayWindow.close(null);
    }

    private setLicenseInfo(): void {
        this.licenseHttpService.getLicenseInfo()
            .subscribe({
                next: (response) => {
                    this.licenseInfo = response.licenseInfo;
                    this.licenseInfoText = this.getLicenseText();
                    this.setIconClass();

                },
                error: async (err) => {
                    this.toastService.show(new ToastSettings(ToastType.Error, "Ошибка при получении данных по лицензии", err));
                }
            });
    }

    private permitStatusKey: IDictionary<string> = {
        'IsValid': 'одобрено',
        'InvalidSignature': 'лицензионный файл не соответствует сигнатуре окружения',
        'Expired': 'срок действия лицензии истек',
        'NoFile': 'не найден лицензионный файл',
        'Corrupted': 'лицензионный файл имеет поврежденную структуру',
        'NoServiceLicense': 'сервис отсутствует в лицензионном файле',
        'NoConnection': 'отсутствует подключение к I-DS/LS'
    };

    private getLicenseText(): string {
        let text = '';
        const validUntil = "Срок действия лицензии";
        const perpetual = "бессрочно";
        const customer = "Заказчик";
        const comment = "Примечание";
        const emergencyMode = "Аварийный режим";
        const left = "осталось";
        const hours = "часов";
        const violation = "Нарушение";
        const permitStatus = this.permitStatusKey[this.licenseInfo.permitStatus];

        if (this.licenseInfo.isPerpetual == true || this.licenseInfo.licenseValidUntil) {
            text += validUntil + ': ' +
                (this.licenseInfo.isPerpetual == true ?
                    perpetual :
                    new Date(this.licenseInfo.licenseValidUntil).toLocaleString()) + '<br />';
        }
        if (this.licenseInfo.customer) {
            text += customer + ': ' + this.licenseInfo.customer + '<br />';
        }
        if (this.licenseInfo.comment) {
            text += comment + ': ' + this.licenseInfo.comment + '<br />';
        }
        if (this.licenseInfo.inEmergencyMode == true) {
            text += emergencyMode + ': ' + left + ' ' +
                this.getHoursFromSeconds(this.licenseInfo.emergencyModeTimeLeftInSeconds) + ' ' + hours + ' / ' +
                new Date(this.licenseInfo.endOfEmergencyMode).toLocaleString() + '<br />';
        }
        if (this.licenseInfo.permitStatus != PermitStatus.IsValid) {
            text += violation + ': ' + permitStatus;
        }

        return text;
    }

    private getHoursFromSeconds(seconds: number): number {
        return Math.floor(seconds / 60 / 60);
    }

    private setIconClass(): void {
        if (this.licenseInfo.inEmergencyMode == true) {
            this.iconClass = 'fas fa-ban license-em-mode-icon';
        }
        else if (this.licenseInfo.permitStatus == PermitStatus.IsValid) {
            this.iconClass = 'far fa-check-circle license-valid-icon';
        }
        else {
            this.iconClass = 'fas fa-ban license-invalid-icon';
        }
    }
}
